import { defineAsyncComponent } from 'vue';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';

const searchBarMap = {
    layout1: searchCenter =>
        searchCenter
            ? import(
                /* webpackChunkName: "modules/md-search-bar-center/layout1" */ './md-search-bar/layout1/index-center.vue'
            )
            : import(
                /* webpackChunkName: "modules/md-search-bar/layout1" */ './md-search-bar/layout1/index.vue'
            ),
    broker: searchCenter =>
        searchCenter
            ? import(
                /* webpackChunkName: "modules/md-search-bar-center/broker" */ './md-search-bar/broker/index-center.vue'
            )
            : import(
                /* webpackChunkName: "modules/md-search-bar/broker" */ './md-search-bar/broker/index.vue'
            ),
    standard: searchCenter =>
        searchCenter
            ? import(
                /* webpackChunkName: "modules/md-search-bar-center/standard" */ './md-search-bar/standard/index-center.vue'
            )
            : import(
                /* webpackChunkName: "modules/md-search-bar/standard" */ './md-search-bar/standard/index.vue'
            ),
    template1: searchCenter =>
        searchCenter
            ? import(
                /* webpackChunkName: "modules/md-search-bar-center/template1" */ './md-search-bar/template1/index-center.vue'
            )
            : import(
                /* webpackChunkName: "modules/md-search-bar/template1" */ './md-search-bar/template1/index.vue'
            ),
    template4: searchCenter =>
        searchCenter
            ? import(
                /* webpackChunkName: "modules/md-search-bar-center/template4" */ './md-search-bar/template4/index-center.vue'
            )
            : import(
                /* webpackChunkName: "modules/md-search-bar/template4" */ './md-search-bar/template4/index.vue'
            )
};

function genComponents(theme, searchCenter) {
    return searchBarMap[theme](searchCenter);
}

export default function(theme) {
    return {
        computed: {
            ...mapState(usePageStore, {
                isSearchCenter: store => store.isSearchCenter
            }),
            // template中引用md-search-bar的时候这样引, <component :is="mdSearchBar"></component>
            mdSearchBar({ isSearchCenter }) {
                return isSearchCenter ? 'MdSearchBarCenter' : 'MdSearchBar';
            }
        },
        components: {
            MdSearchBar: defineAsyncComponent(() =>
                genComponents(theme, false)),
            MdSearchBarCenter: defineAsyncComponent(() =>
                genComponents(theme, true))
        }
    };
}
